import Api from "utils/api";
import { decryptJSON } from "global/security";

function ensurePayload(response, fallbackMessage) {
  if (!response?.success || !response?.data) {
    throw new Error(response?.message || fallbackMessage);
  }

  return decryptJSON(response.data);
}

export async function getVouchersV2() {
  const { response, error } = await Api("/super_admin_v2/vouchers", "get");

  if (error) {
    throw new Error(error?.message || "Failed to load vouchers");
  }

  return ensurePayload(response, "Vouchers are unavailable");
}

export async function getVoucherDetailV2(voucherId) {
  const { response, error } = await Api(`/super_admin_v2/vouchers/${voucherId}`, "get");

  if (error) {
    throw new Error(error?.message || "Failed to load voucher detail");
  }

  return ensurePayload(response, "Voucher detail is unavailable");
}
